import jQuery from "jquery";

import { on } from 'delegated-events'
require('@accessible360/accessible-slick')


jQuery(document).ready(function($) {

    // responsive menu
    jQuery('.mainmenu li:has(ul)').addClass('parent');

    jQuery('.mainmenu a.child-trigger').click(function() {
        jQuery(this).parent().siblings('li').find('a.child-trigger').removeClass('child-open');
        jQuery(this).parent().siblings('li').find('ul').slideUp(250);
        jQuery(this).next('ul').slideToggle(250);
        jQuery(this).toggleClass('child-open');
        return false;
    });

    // CONTENT MENU
    jQuery('.text-content-side-menu-wrapper li:has(ul)').addClass('parent');

    jQuery('.text-content-side-menu-wrapper button.child-trigger').click(function() {
        //jQuery(this).parent().siblings('li').find('a.child-trigger').removeClass('child-open');
        //jQuery(this).parent().siblings('li').find('ul').slideUp(250);
        jQuery(this).prev('a').toggleClass('is-open');
        jQuery(this).next('ul').slideToggle(250);
        jQuery(this).toggleClass('child-open');
        return false;
    });

    if ($('.site-announcement-main') != undefined) {
        let announcementHeight = $('.site-announcement-main').height();
        $('.header_action_wrp').css('top', announcementHeight);


        if ($('.header-blue').length > 0) {
            let marginTop = $('.header-blue').css('margin-top');
            $('.header-blue').css('margin-top', (parseInt(marginTop.replace(/px/, "")) + announcementHeight) + "px");
        }
    }
    $(document).on('click', '.anchorBtn', function(e) {
        var url = e.target.href;
        var hash = url.substring(url.indexOf("#") + 1);
        var offset = $('#Header').height();

        $('html, body').animate({
            scrollTop: $('#' + hash).offset().top - (parseInt(offset) + 30)
        }, 500);

        return false;
    });


    $(document).on('click', '.magnify-img', function(e) {
        var src = $(this).attr('src');
        $('#img-magnify').attr('src', src);
        $('#imgModal').css('display', 'block');
        $('#Header').css('display', 'none');
    });
    $(document).on('click', '.magnify-close', function(e) {

        $('#imgModal').css('display', 'none');
        $('#Header').css('display', 'block');
    });

    $('.keyContactsSlider').slick({
        slidesToShow: 2,
        slidesToScroll: 2,
        speed: 1000,
        cssEase: 'linear',
        touchThreshold: 10,
        dots: true,
        dotsClass: 'slider-dots',
        customPaging: function(slider, i) {
            return '•';
        },
        responsive: [{
                breakpoint: 1030,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 577,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
        ]
    }).on('setPosition', function(event, slick) {
        slick.$slides.css('height', slick.$slideTrack.height() + 'px');
    });

    $('.TeamSlider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        speed: 1000,
        cssEase: 'linear',
        touchThreshold: 10,
        dots: true,
        dotsClass: 'custom_paging',
        customPaging: function(slider, i) {
            return (i + 1) + '/' + slider.slideCount;
        },
        responsive: [{
                breakpoint: 1030,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 577,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
        ]
    }).on('setPosition', function(event, slick) {
        slick.$slides.css('height', slick.$slideTrack.height() + 'px');
    });

    $('.ImpSlider').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        speed: 1000,
        cssEase: 'linear',
        touchThreshold: 10,
        dots: false,
        dotsClass: 'custom_paging',
        customPaging: function(slider, i) {
            return (i + 1) + '/' + slider.slideCount;
        },
        responsive: [{
                breakpoint: 1001,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 577,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    });

    $('.project-slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        speed: 1000,
        cssEase: 'linear',
        touchThreshold: 10,
        dots: true,
        dotsClass: 'custom_paging',
        /*
        customPaging: function(slick, index) {
            var targetImage = slick.$slides.eq( index ).find( 'img' ).attr( 'src' );
            return '<button><img src=" ' + targetImage + ' " alt="image" /></button>';
        },
        */
        customPaging: function(slider, i) {
            return (i + 1) + '/' + slider.slideCount;
        },
        responsive: [{
                breakpoint: 1001,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 577,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    });

    jQuery('.GallerySlider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        draggable: false,
        touchMove: true,
        asNavFor: '.GalleryThumbSlider'
    });

    jQuery('.GalleryThumbSlider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.GallerySlider',
        vertical: true,
        dots: false,
        arrows: true,
        focusOnSelect: true,
        adaptiveHeight: true,
        adaptiveWidth: true,
        margin: '0px',
        responsive: [{
            breakpoint: 768,
            settings: {
                vertical: false,
                slidesToShow: 3,
            }
        }]
    });
    jQuery('.historyMainSlider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        fade: true,
        adaptiveHeight: true,
        asNavFor: '.historyThumbSlider'
    });
    jQuery('.historyThumbSlider').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        asNavFor: '.historyMainSlider',
        dots: false,
        arrows: false,
        centerMode: false,
        focusOnSelect: true,
        // variableWidth: true
        responsive: [{
                breakpoint: 1030,
                settings: {
                    slidesToShow: 5,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 6,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 3,
                }
            }
        ]
    });

    $(document).on('change', '#location-category', function(e) {
        e.preventDefault();
        let URLSegment = $(this).val();
        locationCategory(URLSegment);
    });
    if (typeof SearchSubCategory !== 'undefined') {
        if (SearchSubCategory != null) {
            var URLSegment = $('#location-category').val();
            locationCategory(URLSegment, SearchSubCategory);
        }
    }

    function locationCategory(URLSegment, SearchSubCategory = null) {
        if (URLSegment != '') {
            $.ajax({
                    type: 'GET',
                    url: '/subcategory/' + URLSegment,
                }).done(function(res) {
                    $('#location-subcategory').empty();
                    $('#location-subcategory').append('<option value="">Sub Category</option>');
                    let len = Object.keys(res).length;
                    if (len != 0) {
                        Object.entries(res).forEach(
                            ([key, value]) => $('#location-subcategory').append('<option value="' + key + '"  ' + (SearchSubCategory == key ? 'selected' : '') + '>' + value + '</option>')
                        );
                    }
                })
                .fail(function(xhr) {
                    console.log(xhr)
                });
        } else {
            $('#location-subcategory').empty();
            $('#location-subcategory').append('<option value="">Sub Category</option>');
        }
    }

    jQuery(".expand-collapse-btn").click(function() {
        jQuery(this).toggleClass("active");
        let el = jQuery(this);
        if (el[0].className == 'expand-collapse-btn active') {
            jQuery('.expand-collapse-btn p').html('Collapse to Hide Departments');
        } else {
            jQuery('.expand-collapse-btn p').html('Click to Open Departments');
        }
        jQuery(".dept-list-row").slideToggle(200);
    });

    $('.search-modal-toggle').on('click', function(e) {
        e.preventDefault();
        $('.header-search-box').fadeToggle("fast", "linear");
    });

    $('body').on('click tap', 'button#menu-toggle', function() {
        $('header').addClass('active');
    });

    $('body').click(function(e) {
        if (!$(e.target).is('button#menu-toggle')) {
            $('header').removeClass('active');
            $('div.menu-panel').removeClass('is-active');
        }
    });

    $('nav.slide-out-menu').click(function(e) {
        e.stopPropagation();
    });


    // FAQ ACCORDION
    $(document).on('click', '.accordion-item .title', function(e) {
        var dropDown = jQuery(this).closest('.accordion-item').find('.accordion-content');
        jQuery(this).closest('.accordion-wrapper').find('.accordion-content').not(dropDown).slideUp();

        if (jQuery(this).hasClass('active')) {
            jQuery(this).removeClass('active');
        } else {
            jQuery(this).closest('.accordion-wrapper').find('.accordion-item .title.active').removeClass('active');
            jQuery(this).addClass('active');
        }

        dropDown.stop(false, true).slideToggle();
        e.preventDefault();
    });

    /*
    $('.main-side-panel-trigger').on('click', function() {
        $('.header-side-panel').addClass('show');
    });
    $('.close-side-panel').on('click', function() {
        $('.header-side-panel').removeClass('show');
    });

    $('.menu-panel-trigger').click(function() {
        $('div.menu-inner-panel').removeClass('is-active');

        if ($(this).data('ref')) {
            var targetRef = $(this).data('ref');
            var $target = $('div.menu-inner-panel[data-menu="' + targetRef + '"]');
            $target.addClass('is-active');
        }
    });
    */

    $('.text-content-side-menu-wrapper .hide-side-bar').click(function() {
        $('.text-content-side-menu-wrapper ul, .text-content-side-menu-wrapper .all_dep_wrp').hide(500);
        $('.text-content-side-menu-wrapper .show-side-bar').show(0);
        $('.text-content-side-menu-wrapper .hide-side-bar').hide(0);
    });
    $('.text-content-side-menu-wrapper .show-side-bar').click(function() {
        $('.text-content-side-menu-wrapper ul, .text-content-side-menu-wrapper .all_dep_wrp').show(500);
        $('.text-content-side-menu-wrapper .show-side-bar').hide(0);
        $('.text-content-side-menu-wrapper .hide-side-bar').show(0);
    });


}); //document.ready end here

var headerHeight = jQuery('header').outerHeight();
var headerHeightPluse = jQuery('header').outerHeight() + 20;

$(window).scroll(function() {


    if ($(window).width() > 992) {
        var link = $('.menu-link');
        var logo = $('.site-logo-title');
        var sticky = $('header'),
            scroll = $(window).scrollTop();

        if ($(window).scrollTop() > headerHeight) {
            sticky.addClass('h-sticky');
            // jQuery('body').css('padding-top', headerHeight);
            // jQuery('body').addClass('bodyHome');
        } else {
            sticky.removeClass('h-sticky');

        }

        if ($(window).scrollTop() > headerHeightPluse) {
            sticky.addClass('sticky2');
            link.removeClass('text-white').addClass('text-deepBlue');
            logo.removeClass('text-white').addClass('text-primaryBlue');
            if ($('#Header.relative-header').length !== 0) {
                $('#Header.relative-header').removeClass('relative').addClass('fixed');
                $('#Header.relative-header').addClass('header');
            } else {
                $('.search-icon-white').addClass('hidden');
                $('.search-icon-blue').removeClass('hidden');
            }
        } else {
            sticky.removeClass('sticky2');

            if (document.getElementById('Header').classList.contains('dept-header')) {
                link.removeClass('text-deepBlue').addClass('text-white');
            }

            logo.removeClass('text-primaryBlue').addClass('text-white');
            if ($('#Header.relative-header').length !== 0) {
                $('#Header.relative-header').removeClass('fixed').addClass('relative');
                $('#Header.relative-header').removeClass('header');
            } else {
                $('.search-icon-white').removeClass('hidden');
                $('.search-icon-blue').addClass('hidden');
            }
        }
    }



});

if (typeof eventsDate !== 'undefined') {
    var events = [];

    var eventsdt = JSON.parse(eventsDate);
    eventsdt.forEach(function(v) {
        let dt = v.Date + ' 00:00:00';
        events.push({
            ID: v.ID,
            Date: new Date(dt),

        })
    });
    $(function() {
        $("#datepicker-event").datepicker({
            dateFormat: 'dd-mm-yy',

            beforeShowDay: function(date) {
                var result = [true, "", null];
                var matching = $.grep(events, function(event) {
                    return event.Date.valueOf() === date.valueOf();
                });

                if (matching.length) {
                    result = [true, "highlight", null];
                } else {
                    result = [false, "ui-datepicker-disabled", null];
                }
                return result;
            }

        }).on('change', fn.handleDate);
    });
}



(function($) {
    var Fancybox_opt = {
        autoFocus: true,
        trapFocus: true,
        dragToClose: false,
        mainClass: "simple-modal",
        showClass: "fancybox-fadeIn",
        hideClass: "fancybox-fadeOut",
    };
    Fancybox.bind("[data-src='#simple-modal']", Fancybox_opt);
})(jQuery);

const state = {
    categoryIds: [],
    selectDate: ''
}
const fn = {
    init: () => {
        on('change', '.eventcategory', fn.handleCategory)
        on('click', '.eventbtnSubmit', fn.handleSearch)
    },

    handleCategory: (e) => {
        e.preventDefault()
        var target = e.target;
        if (target.checked) {
            state.categoryIds.push(e.target.value)
        } else {
            var index = state.categoryIds.indexOf(e.target.value);
            if (index !== -1) {
                state.categoryIds.splice(index, 1);
            }
        }

        fn.handleAjaxSubmit()

    },
    handleSearch(e) {
        fn.handleAjaxSubmit()
    },
    handleDate(e) {

        state.selectDate = e.target.value;
        fn.handleAjaxSubmit();
    },
    handleAjaxSubmit() {
        //var search = document.querySelector('#search').value;
        let category = '';

        if (state.categoryIds.length > 0) {
            category = state.categoryIds.join(',');
        }

        const nav = document.querySelector('[data-paginated-list-nav]');
        let list = null;
        if (nav != null) {
            list = nav.previousElementSibling;
        }

        let url = document.querySelector('#event-form').action;
        let href = url + '?category=' + category + '&date=' + state.selectDate;
        ajax
            .url(href)
            .get()
            .json((resp) => {
                if (nav != null) {
                    const newNav = document.createRange().createContextualFragment(resp.nav)
                    nav.parentNode.replaceChild(newNav, nav)
                } else {

                }

		const clearFilter = document.querySelector('.clear-filters')

		if (clearFilter) {
		    clearFilter.classList.add('hidden')

		    if (resp.filtered && resp.total) {
		        clearFilter.classList.remove('hidden')
		    }
		}

                if (resp.list.length > 12) {
                    if (list != null) {
                        list.innerHTML = resp.list
                    } else {
                        $('.event-list-wrapper').empty().append(resp.list)
                    }
                    if (document.querySelector('.more-event') != undefined) {

                        document.querySelector('.more-event').classList.remove('hidden')
                    }
                } else {
                    $('.event-list-wrapper').empty().append('<h1 class="text-lg font-semibold text-center text-deepRed">Result Not Found <br><a href="' + url + '" class="text-lg font-semibold text-center text-deepRed hover:text-primaryBlue">- Clear Filter -</a></h1>');
                    if (document.querySelector('.more-event') != undefined) {

                        document.querySelector('.more-event').classList.add('hidden')

                    }

                }

            })
    }
}

export default {
    can: () => document.querySelector('.eventcategory'),
    //can: () => document.querySelector('.eventbtnSubmit'),
    run: fn.init,
}
